import { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useFilters, usePagination, useSortBy, useTable } from "react-table";

import { MarketsTabModalTableColumns } from "./MarketsTabModalTableColumns";
import {
  FlexContainers,
  Paragraph2,
  SearchInput,
  Table,
  WrapperContainer
} from "../../../components";
import { t } from "../../../services";
import { strCode } from "../../../consts";

const MarketsTabModalTable = ({ markets, isMarketSelected, onMarketSelecting }) => {
  const [searchValue, setSearchValue] = useState("");

  const loading = useSelector((store) => store.markets?.loading);
  const error = useSelector((store) => store.markets?.error);

  const columns = useMemo(() => MarketsTabModalTableColumns, []);
  const tableInstance = useTable(
    {
      columns,
      data: markets,
      initialState: {
        sortBy: [
          {
            id: "name",
            asc: true
          }
        ]
      }
    },
    useFilters,
    useSortBy,
    usePagination
  );

  const { setFilter } = tableInstance;

  const handleFilterChange = (value) => {
    setFilter("name", value);
    setSearchValue(value);
  };

  return (
    <WrapperContainer width="100%">
      <WrapperContainer width="100%" mb={16}>
        <SearchInput
          id="markets-modal-search"
          value={searchValue}
          setValue={handleFilterChange}
          placeholder={t(strCode.SEARCH_MARKETS_PLACEHOLDER)}
        />
      </WrapperContainer>

      {loading && markets.length === 0 ? (
        <WrapperContainer
          Container={FlexContainers.FlexColumnCenter}
          width={"100%"}
          mt={50}
          textAlign={"center"}>
          <Paragraph2>{t(strCode.LOADING)}</Paragraph2>
        </WrapperContainer>
      ) : error ? (
        <WrapperContainer
          Container={FlexContainers.FlexColumnCenter}
          width={"100%"}
          mt={200}
          textAlign={"center"}>
          <Paragraph2>{t(strCode.MARKETS_FETCH_ERROR)}</Paragraph2>
        </WrapperContainer>
      ) : (
        markets && (
          <Table
            tableInstance={tableInstance}
            searchedText={searchValue}
            searchInfo={`${t(strCode.NO_MARKET_CODE_FOUND)} '${searchValue}'.`}
            searchCheckInfo={t(strCode.CHECK_MARKET_CODE_MESSAGE)}
            maxTableHeight="186px"
            maxVisibleRows={1}
            callbackFn1={onMarketSelecting}
            callbackFn2={isMarketSelected}
            onRowClick={onMarketSelecting}
            showTableBorder
            modalTable
            modalTableSmall
          />
        )
      )}
    </WrapperContainer>
  );
};

MarketsTabModalTable.propTypes = {
  markets: PropTypes.arrayOf(
    PropTypes.shape({
      activeAppTypes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      activeUserCount: PropTypes.number.isRequired,
      country: PropTypes.string.isRequired,
      market: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  isMarketSelected: PropTypes.func.isRequired,
  onMarketSelecting: PropTypes.func.isRequired
};

export default MarketsTabModalTable;
